module.exports = __webpack_public_path__ + "static/media/ecos_Stockholm_1.56be614e.jpg";